import * as React from 'react';
import type { ConnectedProps } from 'react-redux';
import { connect } from 'react-redux';
import { compose } from 'redux';

import type { ExtendedColorValue } from '@acceligentllc/shared/enums/color';

import Dropdown from 'af-components/Controls/Dropdown';
import LabelWithColor from 'af-components/LabelWithColor';

import * as CrewTypeActions from 'af-actions/crewType';

import styles from './styles.module.scss';

export interface CrewTypeFilterOption {
	id: number;
	label: string;
	color: ExtendedColorValue;
	isInternal: boolean;
}

interface OwnProps {
	onChange: (option: Nullable<CrewTypeFilterOption>) => void;
}

type Props = OwnProps & ConnectedProps<typeof connector>;

const CrewTypeFilter: React.FC<Props> = (props) => {

	const {
		onChange,
		findAll,
	} = props;

	const [options, setOptions] = React.useState<CrewTypeFilterOption[]>([]);

	const fetchOptions = React.useCallback(async () => {
		const _options = await findAll();
		const formattedOptions = _options.map((option) => ({
			id: option.id!,
			label: option.name,
			color: option.color as ExtendedColorValue,
			isInternal: option.isInternal,
		}));
		setOptions(formattedOptions);
	}, [findAll]);

	React.useEffect(() => {
		fetchOptions();
	}, [fetchOptions]);

	const renderOption = React.useCallback((option: CrewTypeFilterOption) => {
		return (
			<LabelWithColor color={option.color} text={option.label} />
		);
	}, []);

	const filterBy = React.useCallback((option: CrewTypeFilterOption, rawInput: string) => {
		return option.label.toLowerCase().includes(rawInput.toLowerCase());
	}, []);

	return (
		<div className={styles.dropdown}>
			<Dropdown<CrewTypeFilterOption>
				filterable={true}
				filterBy={filterBy}
				hasBlankOption={true}
				onValueChange={onChange}
				options={options}
				placeholder="Select Crew Type"
				renderMenuItem={renderOption}
				valueKey={'id'}
				withCaret={true}
			/>
		</div>
	);
};

function mapDispatchToProps() {
	return {
		findAll: CrewTypeActions.findAllForOrderReportFilter,
	};
}

const connector = connect(null, mapDispatchToProps());

const enhance = compose<React.ComponentType<OwnProps>>(
	React.memo,
	connector
);

export default enhance(CrewTypeFilter);
